import React, { useMemo, useEffect } from 'react';
import { Glide, styled } from '@teko/ds-desktop';
import { trackViewProductList, getTrackingData } from '@teko/tracking';
import { HorizontalSlider } from '../HorizontalSlider/HorizontalSlider.es.js';
import { useDevice } from '../../contexts/DeviceContext.es.js';
import { ProductCard } from '../ProductCard/ProductCard.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCarousel = (_a) => {
  var _b = _a, {
    products = [],
    productsPerRow,
    className,
    regionName,
    hideCtaButton,
    border
  } = _b, props = __objRest(_b, [
    "products",
    "productsPerRow",
    "className",
    "regionName",
    "hideCtaButton",
    "border"
  ]);
  const { isMobile } = useDevice();
  const trackViewProductListData = useMemo(() => {
    return products.map((product) => {
      var _a2, _b2;
      return {
        sku: product.sku || "",
        category: ((_b2 = (_a2 = product.categories) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.name) || ""
      };
    });
  }, [products]);
  useEffect(() => {
    if (trackViewProductListData.length > 0) {
      trackViewProductList(trackViewProductListData);
    }
  }, [JSON.stringify(trackViewProductListData)]);
  if (isMobile) {
    return /* @__PURE__ */ React.createElement("div", {
      className: "wrapper-horizontal-slider"
    }, /* @__PURE__ */ React.createElement(HorizontalSlider, {
      slidesPerView: productsPerRow || 2.3,
      className: "horizontal-slider"
    }, products.map((product) => /* @__PURE__ */ React.createElement(StyledCard, {
      key: product.sku,
      border: !!border
    }, /* @__PURE__ */ React.createElement(ProductCard, __spreadProps(__spreadValues({}, product), {
      tracking: regionName ? getTrackingData({
        regionName,
        isTrackContent: true,
        contentName: product.sku,
        target: "productDetail"
      }) : {},
      addToCart: hideCtaButton ? void 0 : product.addToCart
    }))))));
  }
  return /* @__PURE__ */ React.createElement(Glide, __spreadValues({
    perView: productsPerRow || 5,
    perSwipe: "|",
    className
  }, props), products.map((item) => /* @__PURE__ */ React.createElement(StyledCard, {
    key: item.sku,
    border: !!border
  }, /* @__PURE__ */ React.createElement(ProductCard, __spreadProps(__spreadValues({}, item), {
    tracking: getTrackingData({
      regionName,
      isTrackContent: true,
      contentName: item.sku,
      target: "productDetail"
    }),
    addToCart: hideCtaButton ? void 0 : item.addToCart
  })))));
};
const Card = styled.div`
  background: white;
  border-radius: 0.5rem;
`;
const StyledCard = styled(Card)(({ theme, border }) => __spreadValues({
  height: "100%"
}, border ? {
  border: "1px solid",
  borderColor: theme.colors.divider,
  borderRadius: theme.spacing.s8,
  overflow: "hidden"
} : {}));

export { ProductCarousel };
